module.exports = Marionette.ItemView.extend( {
	template: '#tmpl-qazana-panel-history-no-items',
	id: 'qazana-panel-history-no-items',
	className: 'qazana-panel-nerd-box'
} );
